/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Directive, Input, ElementRef, Renderer } from '@angular/core';
import { OnInit, OnDestroy, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';

import { Subject } from 'rxjs/Subject';
import'rxjs/add/operator/debounceTime';
import align from 'dom-align';
/**
 * Align
 * 参考 https://github.com/react-component/align
 */
export class Align implements OnInit, OnDestroy, OnChanges, AfterViewInit {
/**
 * https://www.npmjs.com/package/dom-align
 */
align: object = {};

     disabled: boolean;

     monitorWindowResize = false;

     monitorBufferTime = 50;
private alignTarget: any;
private resizeHandler: Function;
private resizeEvents = new Subject<any>();
private resizeIndex = 0;
/**
 * @param {?} __renderer
 * @param {?} __elementRef
 */
constructor(
private __renderer: Renderer,
private __elementRef: ElementRef) {

    }
/**
 * @return {?}
 */
ngOnInit(): void {
        this.resizeEvents
            .debounceTime(this.monitorBufferTime)    // wait for 50ms pause in events
            .subscribe((event: any) => {
                this.forceAlign();
            });
    }
/**
 * @return {?}
 */
ngOnDestroy(): void {
        this.stopMonitorWindowResize();
    }
/**
 * @return {?}
 */
ngAfterViewInit(): void {
        this.alignTarget = this.getAlignTarget();

        // if parent ref not attached .... use document.getElementById
        this.forceAlign();
        if (!this.disabled && this.monitorWindowResize) {
            this.startMonitorWindowResize();
        }
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges): void {
        if (changes['disabled']) {
            if (this.monitorWindowResize && !this.disabled) {
                this.startMonitorWindowResize();
            } else {
                this.stopMonitorWindowResize();
            }
        }
    }
/**
 * @return {?}
 */
getHostElement(): HTMLElement {
        return /** @type {?} */(( this.__elementRef.nativeElement as HTMLElement));
    }
/**
 * 需要调整位置的组件，调用align()方法后位置将发生变化
 * @return {?}
 */
getAlignTarget(): any {
        return this.getHostElement();
    }
/**
 * 基准组件，位置不会变
 * @return {?}
 */
getBaseTarget(): any {
        return null; // will be overrided by subclass
    }
/**
 * @return {?}
 */
startMonitorWindowResize(): void {
        if (!this.resizeHandler) {
            this.resizeHandler = this.__renderer.listen('window', 'resize', () => {
                this.resizeEvents.next(this.resizeIndex++);
            });
        }
    }
/**
 * @return {?}
 */
stopMonitorWindowResize(): void {
        if (this.resizeHandler) {
            this.resizeEvents.complete();
            this.resizeHandler(); // remove event listener
            this.resizeHandler = null;
        }
    }
/**
 * @return {?}
 */
getAlign(): {} {
        return this.align;
    }
/**
 * @return {?}
 */
forceAlign(): void {
        if (!this.disabled) {
            const /** @type {?} */ baseTarget = this.getBaseTarget(); // 基准组件，位置不会变
            if (baseTarget && this.alignTarget) {
                // https://www.npmjs.com/package/dom-align
                const /** @type {?} */ alignConfig = this.getAlign();
                this.onAlign(align(this.alignTarget, baseTarget, alignConfig));
            }
        }
    }
/**
 * @param {?} align
 * @return {?}
 */
onAlign(align: any): void {
        // will be overrided by subclass
    }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    // tslint:disable-next-line:directive-selector
    selector: 'nothing-to-do-here'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'align': [{ type: Input },],
'disabled': [{ type: Input },],
'monitorWindowResize': [{ type: Input },],
'monitorBufferTime': [{ type: Input },],
};
}

function Align_tsickle_Closure_declarations() {
/** @type {?} */
Align.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Align.ctorParameters;
/** @type {?} */
Align.propDecorators;
/**
 * https://www.npmjs.com/package/dom-align
 * @type {?}
 */
Align.prototype.align;
/** @type {?} */
Align.prototype.disabled;
/** @type {?} */
Align.prototype.monitorWindowResize;
/** @type {?} */
Align.prototype.monitorBufferTime;
/** @type {?} */
Align.prototype.alignTarget;
/** @type {?} */
Align.prototype.resizeHandler;
/** @type {?} */
Align.prototype.resizeEvents;
/** @type {?} */
Align.prototype.resizeIndex;
/** @type {?} */
Align.prototype.__renderer;
/** @type {?} */
Align.prototype.__elementRef;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
